import * as React from 'react'

import Loading from './Loading'

function LoadingComponent() {
  return (
    <div className="absolute w-full h-full top-0 bg-screen left-0">
      <Loading skipLogoutMessage />
    </div>
  )
}

export default LoadingComponent
